<template>
  <div class="user-tab-bar">
    <md-tab-bar
      :items="titles"
      :has-ink="true"
      v-model="currentTab"
      class="tabs"
      @change="switchRoute"
    >
      <template slot="item" slot-scope="{ item }">
        <div class="custome-item">
          <img :src="item.icon" class="item-img">
          <div class="item-text">{{ item.label }}</div>
        </div>
      </template>
    </md-tab-bar>
  </div>
</template>

<script>
import { TabBar } from 'mand-mobile'

export default {
  components: {
    [TabBar.name]: TabBar,
  },
  i18n: {
    messages: {
      en: {
        overview: 'Overview',
        lending: 'Lending',
        transaction: 'Transaction',
        security: 'Security',
        package: 'Discount',
      },
      id: {
        overview: 'Ikhtisar',
        lending: 'Pendanaan',
        transaction: 'Transaksi',
        security: 'Keamanan Akun',
        package: 'Diskon',
      },
    },
  },
  data() {
    const investorEnabled = this.$store.state.userInfo.status === 'ENABLED'
    const titles = {
      enabled: [
        {
          name: 1,
          label: this.$t('overview'),
          route: 'UserOverview',
          icon: require('@/assets/image/dashboard/sidebar/overview.svg'),
        },
        {
          name: 2,
          label: this.$t('transaction'),
          route: 'UserTransaction',
          icon: require('@/assets/image/dashboard/sidebar/transaction.svg'),
        },
        {
          name: 3,
          label: this.$t('security'),
          route: 'UserSecurity',
          icon: require('@/assets/image/dashboard/sidebar/profile.svg'),
        },
        {
          name: 4,
          label: this.$t('package'),
          route: 'UserTicket',
          icon: require('@/assets/image/dashboard/sidebar/coupon.svg'),
        },
      ],
      initial: [
        {
          name: 1,
          label: this.$t('overview'),
          route: 'UserOverview',
          icon: require('@/assets/image/dashboard/sidebar/overview.svg'),
        },
        {
          name: 2,
          label: this.$t('security'),
          route: 'UserSecurity',
          icon: require('@/assets/image/dashboard/sidebar/profile.svg'),
        },
        {
          name: 3,
          label: this.$t('package'),
          route: 'UserTicket',
          icon: require('@/assets/image/dashboard/sidebar/coupon.svg'),
        },
      ],
    }[investorEnabled ? 'enabled' : 'initial']
    return {
      titles: titles,
      currentTab: 'UserOverview',
    }
  },
  methods: {
    switchRoute(item, index) {
      this.$router.push({ name: this.titles[index].route })
    },
  },
  watch: {
    $route: function(newVal, oldVal) {
      if (newVal) {
        const currentTitle = this.titles.find(i => i.route === newVal.name)
        this.currentTab = currentTitle ? currentTitle.name : this.titles[0].name
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.user-tab-bar /deep/ {
  z-index: 102;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60px;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.04), 0 0 4px 0 rgba(0, 0, 0, 0.04), 0 0 4px 0 rgba(0, 0, 0, 0.18);
  .md-tab-bar {
    height: 100%;
    .md-tab-bar-inner {
      height: 100%;
      .scroll-view-container {
        height: 100%;
      }
    }
    .md-tab-bar-list {
      align-items: center;
      height 100%
      .md-tab-bar-item {
        min-width: 20%;
        max-width: 20%;
        height: 100%;
        text-align: center;
        .custome-item {
          height: 100%;
          font-size: 10px;
          display: flex;
          cursor: pointer;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .item-img {
            width: 30px;
            height: 30px;
          }
          .item-text {
            line-height: 1em;
          }
        }
      }
    }
  }
}
</style>
